import { StrictMode, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateTimer } from "./Poker/redux/slices/timersSlice";
import {
  subscribeToTimerWorker,
  getTimerWorkerInstance,
} from "./src/workers/timerWorkerInstance";
import { createHashRouter, RouterProvider, Routes, Route } from "react-router";
// import Home from "./src/routes/Home/Home";
import { Home, CashLobby, CashLobbyRoom, TourneyLobby, Stats } from "@themed-routes";
import PlatformServiceProvider from "./src/providers/PlatformServiceProvider";
import LobbyServiceProvider from "./src/providers/LobbyServiceProvider";
import GameServiceProvider from "./src/providers/GameServiceProvider";
import { Toaster } from "sonner";
import { terminateTimerWorker } from "./src/workers/timerWorkerInstance";
import LobbyDisconnectionProvider from "./src/providers/LobbyDisconnectionProvider";
import RestrictionProvider from "./src/providers/RestrictionProvider";
import GameTablesLayout from "./src/routes/Game/GameTablesLayout";
import Cashier from "./src/routes/Cashier/Cashier";
import TourneyDetails from "./src/routes/TourneyDetails/TourneyDetails";

// import { terminateTimerWorker } from "@/workers/timerWorkerInstance";

// The reason for wrapping all the service providers within the router is so that we can use the react-router hooks in them.
// React Router hooks can only be called within the context of a router. (eg: useNavigate for lackGames in gameServiceProvider)

// if (import.meta.env.VITE_REACT_APP_DISABLE_CONSOLE_STATEMENTS) {
// console.log = () => null;
// }

// Wrapper component that provides all services
const AppProviders = ({ children }) => {
  return (
    <PlatformServiceProvider>
      <LobbyServiceProvider>
        <RestrictionProvider>
          <GameServiceProvider>
            {children}
            <Toaster
              style={{
                fontFamily: "var(--font-primary)",
                background: "var(--color-background)",
              }}
              position="top-center"
            />
          </GameServiceProvider>
        </RestrictionProvider>
      </LobbyServiceProvider>
    </PlatformServiceProvider>
  );
};

// Main app component with routing
const AppContent = () => {
  return (
    <Routes>
      <Route element={<LobbyDisconnectionProvider />}>
        <Route path="/" element={<Home />} />
        <Route path="/cashLobby" element={<CashLobby />} />
        <Route path="/cashLobbyRoom/:roomId" element={<CashLobbyRoom />} />
        <Route path="/tourneyLobby" element={<TourneyLobby />} />
        <Route path="/tourneyDetails/:tourneyId" element={<TourneyDetails />} />
      </Route>
      <Route path="/game" element={<GameTablesLayout />} />
      <Route path="/cashier" element={<Cashier />} />
      <Route path="/stats" element={<Stats />} />
    </Routes>
  );
};

const router = createHashRouter([
  {
    path: "*",
    element: (
      <AppProviders>
        <AppContent />
      </AppProviders>
    ),
  },
]);

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Subscribe to timer worker updates and dispatch to Redux
    const unsubscribe = subscribeToTimerWorker((event) => {
      console.log(
        "YASHWANTH APP JS Received timer update from worker:",
        event.data
      );
      // if (event.data && event.data.type === "timerUpdate") {
      if (event.data) {
        dispatch(
          updateTimer({
            timerId: event.data.timerId,
            value: event.data.value,
            status: "running",
            timerType: event.data.type,
          })
        );
      }
    });
    // Optionally, ensure worker is created
    getTimerWorkerInstance();
    return () => {
      unsubscribe();
      terminateTimerWorker();
    };
  }, [dispatch]);

  return (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
};

export default App;
